import { createSelector } from "reselect"
import { get, map, chain, replace, kebabCase } from "lodash"
import moment from "moment"
import { computeDriftValues, findTradeStatus } from "helpers/drift"

const getFactorPerformanceHistory = state => get(state, "global.data.factorProfilePerformance.data.model.factors[0].performance")
const getFactorPredictiveRisk = state => get(state, "global.data.factorProfileRisk.data.model.factors[0].risk")
export const getFactorLabel = state => get(state, "global.data.factorProfilePerformance.data.model.factors[0].name")
export const getFactorCategory = state => get(state, "global.data.factorProfilePerformance.data.model.factors[0].category")

export const getPerformanceHistory = createSelector(
  [getFactorPerformanceHistory],
  (factorHistory) => map(factorHistory, (item, index) => ({
    date: moment(item.date).toDate(),
    value: item.percentPriceChangeCumulative,
    index,
  })),
)

export const getNormalizedHistory = createSelector(
  [getFactorPerformanceHistory],
  (factorHistory) => map(factorHistory, (item, index) => ({
    index,
    date: moment(item.date).toDate(),
    value: item.normalizedReturn,
    label: findAbbreviatedTradeStatus(item.normalizedReturn),
    labelClassname: findTradeStatusClassname(item.normalizedReturn),
  })),
)

function findAbbreviatedTradeStatus(normalizedReturnValue) {
  return replace(findTradeStatus(normalizedReturnValue), "Extremely", "Ext")
}

function findTradeStatusClassname(normalizedReturnValue) {
  return kebabCase(findTradeStatus(normalizedReturnValue))
}

export const getCurrentNormalized = createSelector(
  [getNormalizedHistory],
  (normalizedHistory) => chain(normalizedHistory)
    .last()
    .get("value")
    .value(),
)

export const getPredictiveRiskHistory = createSelector(
  [getFactorPredictiveRisk],
  (factorRisk) => {
    return map(factorRisk, (item, index) => ({
      date: moment(item.date).toDate(),
      value: item.value,
      index,
    }))
  },
)

export const getPredictiveRiskDriftValues = createSelector(
  [getPredictiveRiskHistory],
  (riskHistory) => {
    return computeDriftValues(map(riskHistory, "value"))
  },
)
